import React from 'react';
import NotesWrapper from '../../Notes/NotesWrapper';
const OfficerAssessmentNotesShareWrapper = (props) => (React.createElement(NotesWrapper, { ...props, canEdit: false, type: "officerAssessment", notes: props.model.notes }));
export default OfficerAssessmentNotesShareWrapper;
